// Time helpers for the BOPIS scheduler: every time shown or edited is
// America/New_York wall clock, whatever the browser's zone.

export const TZ = 'America/New_York';

// ISO instant → its ET calendar date and 24h time.
export function etParts(iso) {
  const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(new Date(iso)).map((x) => [x.type, x.value]));
  return { date: `${p.year}-${p.month}-${p.day}`, time: `${p.hour}:${p.minute}` };
}

// "YYYY-MM-DD" + "HH:MM" read as ET → ISO instant with the right ET offset.
export function etToISO(date, time) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date || '');
  const t = /^(\d{2}):(\d{2})$/.exec(time || '');
  if (!m || !t) return null;
  const asUTC = Date.UTC(+m[1], +m[2] - 1, +m[3], +t[1], +t[2]);
  // Offset of ET at that moment: format the UTC guess in ET and diff.
  const g = etParts(new Date(asUTC).toISOString());
  const etAsUTC = Date.parse(`${g.date}T${g.time}:00Z`);
  return new Date(asUTC + (asUTC - etAsUTC)).toISOString();
}

// "13:05" → "1:05 PM"
export function fmtClock(time) {
  const [h, m] = time.split(':').map(Number);
  const hour12 = h % 12 || 12;
  return `${hour12}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;
}

// Every quarter hour of the day, plus `current` if it is off that grid,
// so an existing time never shifts just by opening the editor.
export function timeOptions(current) {
  const values = [];
  for (let h = 0; h < 24; h++) {
    for (const m of [0, 15, 30, 45]) values.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
  }
  if (current && !values.includes(current)) values.push(current);
  values.sort();
  return values.map((value) => ({ value, label: fmtClock(value) }));
}
